module.exports = {"320585100":"城厢镇","320585101":"沙溪镇","320585102":"浏河镇","320585103":"浮桥镇","320585104":"璜泾镇","320585105":"双凤镇","320585400":"经济开发区","320585403":"科教新城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320585.json
// module id = 972
// module chunks = 0